import {
  FormHelperText,
  //   InputLabel,
  RadioGroupProps,
  FormControlProps,
  Typography,
  Stack,
  Box,
} from "@mui/material"
import FormControl from "@mui/material/FormControl"
import FormControlLabel from "@mui/material/FormControlLabel"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"
import { isEmpty } from "lodash"
import React from "react"
import { Controller, FieldValues, UseControllerProps } from "react-hook-form"

type Option = {
  value: string | number
  label: string
  description?: string
}

export interface ControlledRadioGroupProps<FieldValueProps extends FieldValues>
  extends UseControllerProps<FieldValueProps> {
  label: string
  options: Option[]
  RadioGroupProps?: RadioGroupProps
  FormControlProps?: FormControlProps
}

function ControlledRadioGroup<FieldValueProps extends FieldValues>({
  RadioGroupProps = {},
  FormControlProps = {},
  options = [],
  control,
  name,
  label,
  ...props
}: ControlledRadioGroupProps<FieldValueProps>) {
  return (
    <Controller
      {...props}
      control={control}
      name={name}
      render={({ fieldState: { error }, field: { onChange, value } }) => (
        <FormControl {...FormControlProps} error={!isEmpty(error)}>
          <Box>
            <Typography id={name}>{label}</Typography>
            <RadioGroup
              {...RadioGroupProps}
              onChange={onChange}
              aria-labelledby={name}
              name={name}
              sx={{ paddingTop: "4px" }}
            >
              {options.map((radioBtn) => {
                return (
                  <Stack key={radioBtn.value}>
                    <FormControlLabel
                      key={radioBtn.value}
                      value={radioBtn.value}
                      control={<Radio checked={value == radioBtn.value} />}
                      label={radioBtn.label}
                    />
                    <Typography sx={{ ml: 4 }} variant="caption">
                      {radioBtn?.description ?? ""}
                    </Typography>
                  </Stack>
                )
              })}
            </RadioGroup>
            <FormHelperText>{error?.message ?? ""}</FormHelperText>
          </Box>
        </FormControl>
      )}
    />
  )
}

export default ControlledRadioGroup
